import type {ReactElement} from 'react';
import type {VoiceProfilesDropdownPopupProps} from './voice-profiles-dropdown-popup.types';
import type {PlayableSubfilter} from '@Panels/ai-voice-panel/ai-voice-panel.types';
import {getVoiceFilters} from '@Panels/ai-voice-panel/ai-voice-panel.types';
import {Text, TextSize} from '@Components/text';
import {VoiceProfileItem} from '../voice-profile-item/voice-profile-item';

export function VoiceProfilesDropdownPopup(props: VoiceProfilesDropdownPopupProps): ReactElement<HTMLDivElement> {
  const {selectedProfileId, isSmallScreen} = props;

  return (
    <div className={`ct-neutral-primary ${isSmallScreen ? '' : 'spacing-p-t-1 spacing-p-l-1 spacing-p-r-1'} spacing-p-b-1 flexbox flex-column`}>
      {!isSmallScreen ? <Text val={window.i18next.t('pmwjs_voice_profiles')} size={TextSize.XXSMALL} bold className={'spacing-m-b-2'} /> : null}
      <div className={'flexbox flex-column gap-3'}>
        {getVoiceFilters().map((profile: PlayableSubfilter) => {
          return <VoiceProfileItem key={profile.id} profile={profile} isSelected={selectedProfileId === profile.id} onProfileSelected={props.onProfileSelected} />;
        })}
      </div>
    </div>
  );
}
